module.exports = __webpack_public_path__ + "static/media/Hammer and Felt.10ecad5c.jpg";